module.exports = __webpack_public_path__ + "ptc_momoro_H1.d42ac7c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_H1.jpg
// module id = c8R7
// module chunks = 0